import { dxUiNotify } from '@/utils/dx-helper';

const types = ['error', 'info', 'success', 'warning'];

/**
 * @type {Object.<string, Function>}
 * @property {Function} error
 * @property {Function} info
 * @property {Function} success
 * @property {Function} warning
 */
export const DxUiNotify = (() => {
    return types.reduce((accumulator, type) => {
        return {
            ...accumulator,
            [type](message) {
                dxUiNotify({ options: { closeOnClick: true }, type, message,closeOnClick: true,  width: 'fit-content' });
            },
        };
    }, {});
})();
